export const UNICODE = {
    ELLIPSIS: '\u2026',
};
